import Form from "@/views/App/Portal/GroupCoaching/FirstInterview/Form.vue";
import List from "@/views/App/Portal/GroupCoaching/Protocol/List.vue";
import FirstAppointmentList from "@/views/App/Portal/GroupCoaching/InvitationToFirstAppointment/List.vue";
import FinalInterviewForm from "@/views/App/Portal/GroupCoaching/FinalInterview/Form.vue";
import DocumentsForm from "@/views/App/Portal/GroupCoaching/IntroductoryDocuments/Form.vue";
import MeetingList from "@/views/App/Portal/GroupCoaching/MeetingList/List.vue";

const routesPortalGroupCoaching = [
    {
        path: 'first-interview/:id',
        name: 'groupCoachingFirstInterviewForm',
        component: Form
    },
    {
        path: 'protocol-list/:id',
        name: 'groupCoachingProtocolList',
        component: List
    },
    {
        path: 'invitation-to-first-appointment-list/:id',
        name: 'groupCoachingInvitationToFirstAppointmentList',
        component: FirstAppointmentList
    },
    {
        path: 'final-interview-form/:id',
        name: 'groupCoachingFinalInterviewForm',
        component: FinalInterviewForm
    },
    {
        path: 'documents-form/:id',
        name: 'groupCoachingDocumentsForm',
        component: DocumentsForm
    },
    {
        path: 'meeting-list/:id',
        name: 'groupCoachingCoachingMeetingList',
        component: MeetingList
    }
];

export default routesPortalGroupCoaching;